module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "offer-img"
  }, [(_vm.imageUrl) ? _c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "offer-block"
  }, [_c('div', {
    staticClass: "offer-title truncate"
  }, [_vm._v(_vm._s(_vm.fields.name))]), _c('div', {
    staticClass: "offer-reach"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.reach')))]), _c('div', {
    staticClass: "offer-expires clearfix"
  }, [_c('icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fields.expiresText))])], 1), _c('div', {
    staticClass: "offer-expires clearfix"
  }, [(_vm.settings.isOnline) ? _c('icon', {
    attrs: {
      "name": "globe"
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.fields.redeemText))], 1)]), (_vm.settings.showOnline) ? _c('div', {
    staticClass: "offer-block offer-code"
  }, [_c('div', [_c('div', {
    staticClass: "code break"
  }, [_vm._v(_vm._s(_vm.fields.offer_config.code))]), _c('div', {
    staticClass: "code-details"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.to-redeem-online')))])]), _c('div', [_c('b-btn', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.copy-code')))])], 1)]) : _vm._e(), (_vm.settings.showInStore) ? _c('div', {
    staticClass: "offer-block offer-code"
  }, [_c('div', [_c('div', {
    staticClass: "code break"
  }, [_vm._v(_vm._s(_vm.fields.offer_config.code))]), _c('div', {
    staticClass: "code-details"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.to-redeem-store')))])])]) : _vm._e(), _c('div', {
    staticClass: "offer-block b-top"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('div', [_c('icon-custom', {
    attrs: {
      "name": "hand-holding-box"
    }
  }), _vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.save-for-later')))], 1), _c('div', [_c('icon', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.mark-as-used')))], 1), _c('div', [_c('icon', {
    attrs: {
      "name": "share"
    }
  }), _vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.share-offer')))], 1)])]), _c('div', {
    staticClass: "offer-block"
  }, [_c('div', {
    staticClass: "offer-details title"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.details')))]), _c('div', {
    staticClass: "offer-details truncate"
  }, [_vm._v(_vm._s(_vm.fields.offer_config.details))]), _c('div', {
    staticClass: "offer-details title"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.form.terms-and-conditions')))]), _c('div', {
    staticClass: "offer-details truncate"
  }, [_vm._v(_vm._s(_vm.fields.offer_config.t_c))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-582b8705"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/offer-form-preview/OfferFormPreview.vue
// module id = 2047
// module chunks = 1